import { createRouter, createWebHistory } from 'vue-router';
import CourseSchedule from '../views/CourseSchedule.vue';
import Feedback from '../views/Feedback.vue';
import PastCourses from '../views/PastCourses.vue';
import Stay from '../views/Stay.vue';
import Massage from '../views/Massage.vue';
import Yogatherapy from '../views/Yogatherapy.vue';
import Rides from '../views/Rides.vue';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      redirect: '/schedule',
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: CourseSchedule
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback
    },
    {
      path: '/past-courses',
      name: 'past-courses',
      component: PastCourses
    },
    {
      path: '/stay',
      name: 'stay',
      component: Stay
    },
    {
      path: '/massage',
      name: 'massage',
      component: Massage
    },
    {
      path: '/yogatherapy',
      name: 'yogatherapy',
      component: Yogatherapy
    },
    {
      path: '/rides',
      name: 'rides',
      component: Rides
    }
  ]
});

export default router;